/*****************************************
 * * IMPORTS
 *****************************************/
// React libraries
import React, { Component } from 'react';

// styles and images
import playImg from '../../assets/icons/play.svg';
import pauseImg from '../../assets/icons/pause.svg';
import repeatImg from '../../assets/icons/repeat.svg';
import plusImg from '../../assets/icons/plus.svg';
import minusImg from '../../assets/icons/minus.svg';
// import spinImg from '../../assets/icons/spin.webp';

import styles from './Main.module.css';

// components
import ChartCanvas from '../chart/ChartCanvas';
import Select from '../buttons/Select';
import ImgBtn from '../buttons/ImgBtn';
import SimpleBtn from '../buttons/SimpleBtn';
import StepSlider from '../buttons/StepSlider';

// code
import data, { uiData } from '../../logic/data';
import { restart, play, step } from '../../logic/process';
import calcFunctions from '../../logic/calc';

/*****************************************
 * * CREATE COMPONENT
 *****************************************/

class Main extends Component {
  state = {
    exampleIdx: data.exampleIdx,
    playState: 'pause',
    clickDisable: false,

    rotateDegree: '180deg',
    rate: 2, // fast/slow - 2 is fast
    Ki: 0.1, // will be changed by slider value
    data: calcFunctions.calcInit0(),
  };

  // after component is rendered
  componentDidMount = () => {
    restart.bind(this)(false);
  };

  componentWillUnmount = () => {
    clearInterval(this.intervalID);
  };

  getState = () => this.state;

  // change pay/pause state
  // must be arrow because of this
  changePlayState = val => this.setState({ playState: val });

  // play/pause was clicked
  handlePlayClick = () => play.bind(this)();

  // disable/enable play click on transitions
  setPlayClickDisable = val => this.setState({ playClickDisable: val });

  // text button
  handleBtnClick = (idx, val) => {
    this.changePlayState('pause');
    if (val === 'step') {
      setTimeout(step.bind(this), 0);
    }
  };

  handleRateChange = (idx, val) => {
    this.setState({ rate: idx === 0 ? 2 : 3 });
  };

  // slider handlers

  // slider value change
  handleSliderChange = val => {
    this.setState({ Ki: val });
    // restart the process
    this.handleExampleChange(this.state.exampleIdx);
  };

  // slider minus/plus handlers
  handleMinusClick = () => {
    let Ki = this.state.Ki;
    if (Ki > uiData.sliderMin) {
      Ki -= uiData.sliderStep;
    }
    this.handleSliderChange(Ki);
  };

  handlePlusClick = () => {
    let Ki = this.state.Ki;
    if (Ki < uiData.sliderMax) {
      Ki += uiData.sliderStep;
    }
    this.handleSliderChange(Ki);
  };

  // change playing example
  handleExampleChange = val => {
    // console.log('[EXAMPLE]', val);
    this.props.onExampleChange(val);
    this.setState({
      exampleIdx: val,
      rotateDegree: '180deg',
    });
    setTimeout(restart.bind(this), 0);
  };

  // restart playing from start on the same example
  handleRepeatClick = () => {
    this.handleExampleChange(this.state.exampleIdx);
  };

  // HTML code
  render() {
    const playPauseImg = this.state.playState === 'play' ? pauseImg : playImg;

    return (
      <main className={styles.main}>
        {/* {this.state.busy && <Spinner />} */}

        {/* chart */}
        <div className={styles.chart}>
          <ChartCanvas
            size={data.size}
            data={this.state.data.chartData}
            title={data.chartTitle}
          >
            {/* speedometer */}
            <div className={styles.speedometer}>
              <div
                className={styles.hand}
                style={{
                  transform: `translate(-50%, 0) rotate(${this.state.rotateDegree})`,
                }}
              ></div>
            </div>
          </ChartCanvas>
        </div>
        {/* inputs */}

        {/* slider */}
        <div className={styles.slider}>
          <ImgBtn src={plusImg} onClick={this.handlePlusClick} small={true} />
          <StepSlider
            title={uiData.sliderTitle}
            onChange={this.handleSliderChange}
            marks
            min={uiData.sliderMin}
            max={uiData.sliderMax}
            step={uiData.sliderStep}
            value={this.state.Ki}
            valueLabelDisplay="on"
          />
          <ImgBtn src={minusImg} onClick={this.handleMinusClick} small={true} />
        </div>

        {/* input buttons */}
        <div className={styles.inputs}>
          <ImgBtn src={playPauseImg} onClick={this.handlePlayClick} />
          <ImgBtn src={repeatImg} onClick={this.handleRepeatClick} />
          {/* <ImgBtn src={stepImg} onClick={this.onStepClick} title="step" /> */}
          {/* text buttons */}
          {uiData.buttons.map((btn, idx) => {
            let disabled = false;
            return (
              <SimpleBtn
                key={idx}
                obj={btn}
                disabled={disabled}
                onClick={this.handleBtnClick.bind(this, idx)}
              />
            );
          })}

          {/* rate selection */}
          <Select
            options={uiData.selectRate}
            selectedIdx={this.getState().rate === 2 ? 0 : 1}
            onSelectChange={this.handleRateChange}
          />

          {/* example selection */}
          <Select
            options={uiData.selectExample}
            selectedIdx={this.getState().exampleIdx}
            onSelectChange={this.handleExampleChange}
          />
        </div>
      </main>
    );
  }
}

export default Main;
